const SelectFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/selectFilter/selectFilter.tpl.html',
    controller: 'selectFilterController',
    bindings: {
        criterionTemplate: '<',
        multiSelect: '<',
        submission: '<',
        advancedFilterType: '<',
        translationsKey: '<?'
    }
};

angular.module('umCore')
    .component('uiSelectFilter', SelectFilterComponent);
